document.body.classList.add('is-page-transition');

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Ensuite, au load :
window.addEventListener('load', () => {
  window.scrollTo(0, 0); // remonter en haut
});

import './modules/@tc';
import 'classlist-polyfill';
import 'object-fit-polyfill';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
//import { disablePageScroll, enablePageScroll, adjustScrollbarWidth } from '@fluejs/noscroll';
import barba from '@barba/core';

const overlay = document.querySelector('.transition-overlay');
const logo = document.querySelector('.logo');
const scrollContainer = document.querySelector('.dialog-off-canvas-main-canvas');

function initInView() {
  const elements = document.querySelectorAll('.js-inview');
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px -20% 0px'
  });

  elements.forEach(el => observer.observe(el));
}

function updateLogoState() {
  const logoLink = document.querySelector('.branding'); // adapte le sélecteur
  if (!logoLink) return;

  const logoHref = new URL(logoLink.href).pathname;
  const currentPath = window.location.pathname;

  if (logoHref === currentPath) {
    logoLink.classList.add('inactive'); // désactive le clic via CSS
  } else {
    logoLink.classList.remove('inactive'); // réactive si on navigue ailleurs
  }
}

updateLogoState();

// PARRALAX 
function initParallaxTitle() {

  const items = document.querySelectorAll('.parallax');

  if (!items.length) return;

  let currentScroll = window.scrollY;
  let targetScroll = window.scrollY;
  let ticking = false;

  const updateScroll = () => {
    targetScroll = window.scrollY;
  };

  window.addEventListener('scroll', updateScroll);

  function animate() {

    currentScroll += (targetScroll - currentScroll) * 0.08;

    items.forEach(item => {

      const speed = parseFloat(item.dataset.speed) || 0.1;

      // petite amplitude propre
      const y = currentScroll * speed;

      item.style.transform = `translate3d(0, ${y}px, 0)`;
    });

    requestAnimationFrame(animate);
  }

  if (!ticking) {
    animate();
    ticking = true;
  }
}

// ------------------------------
// Overlay + Logo Animation
// ------------------------------
function playOverlaySequence(firstLoad = false, callback) {
  if (!overlay || !logo) return;
  updateLogoState();

  overlay.style.display = 'flex';
  overlay.style.transition = 'none';
  logo.style.opacity = 0;
  logo.style.transition = 'none';

  if (firstLoad) {
    overlay.style.transform = 'translateY(0)';
    requestAnimationFrame(() => {
      logo.style.transition = 'opacity 0.6s ease';
      logo.style.opacity = 1;

      setTimeout(() => {
        logo.style.opacity = 0;
        
        setTimeout(() => {
          overlay.style.transition = 'transform 0.6s ease';
          overlay.style.transform = 'translateY(-100%)';
          document.body.classList.remove('first-visit');

          setTimeout(() => {
            overlay.style.display = 'none';
            
            if (callback) callback();
          }, 600);
        }, 600);
      }, 600); // fade-in 0.8s + visible 2s
    });
  } else {
    overlay.style.transform = 'translateY(100%)';
    requestAnimationFrame(() => {
      overlay.style.transition = 'transform 0.6s ease';
      overlay.style.transform = 'translateY(0)';

      setTimeout(() => {
        logo.style.transition = 'opacity 0.6s ease';
        logo.style.opacity = 1;

        setTimeout(() => {
          logo.style.opacity = 0;

          setTimeout(() => {
            overlay.style.transition = 'transform 0.6s ease';
            overlay.style.transform = 'translateY(-100%)';

            setTimeout(() => {
              overlay.style.display = 'none';

              if (callback) callback();
            }, 600);
          }, 600);
        }, 600);
      }, 600);
    });
  }
}

// ------------------------------
// Masonry
// ------------------------------
let homepageMasonry = null;
let projetsMasonry = null;

function initMasonry(container, options = {}) {
  if (!container) return null;
  return new Masonry(container, {
    itemSelector: '.--masonry-item',
    percentPosition: true,
    ...options
  });
}

function setupHomepageMasonry() {
  const container = document.querySelector('.homepage-wrapper .projets-view .flexed');
  if (!container) return;
  imagesLoaded(container, () => {
    if (homepageMasonry) homepageMasonry.destroy();
    homepageMasonry = initMasonry(container, { columnWidth: '.grid-sizer' });
  });
}

function setupProjetsMasonry() {
  const container = document.querySelector('.projets-wrapper .projets-view .flexed');
  if (!container) return;
  const gutter = window.innerWidth >= 1600 ? 120 :
                 window.innerWidth >= 1200 ? 80 : 60;
  imagesLoaded(container, () => {
    if (projetsMasonry) projetsMasonry.destroy();
    projetsMasonry = initMasonry(container, { gutter });
  });
}

window.addEventListener('resize', () => {
  setupHomepageMasonry();
  setupProjetsMasonry();
  const body = document.body;
  const isOpenTest = body.classList.contains('mobilmenu-open');
  
  if (isOpenTest) {
    body.classList.remove('mobilmenu-open');
  }
});

// ------------------------------
// Header + Accordions
// ------------------------------
function initHeaderAndAccordions() {
  const header = document.getElementById('header');
  let lastScroll = 0;
  let scrollUpStart = null;
  const showThreshold = 40;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
  
    if (currentScroll > lastScroll && currentScroll > 100) {
      // Descente : masque immédiatement
      header.classList.add('scrolled');
      header.classList.remove('not-top');
      scrollUpStart = null;
    } else if (currentScroll < lastScroll) {
      // On mémorise le début de la remontée
      if (scrollUpStart === null) {
        scrollUpStart = currentScroll;
      }
  
      // On retire "scrolled" seulement après X px remontés
      if (scrollUpStart - currentScroll >= showThreshold) {
        header.classList.remove('scrolled');
      }
  
      // "not-top" garde son comportement actuel
      if (currentScroll > 0) {
        header.classList.add('not-top');
      }
    }
  
    if (currentScroll === 0) {
      header.classList.remove('not-top');
    }
  
    lastScroll = currentScroll;
  });
  document.querySelectorAll('.paragraph--type--accordion').forEach((accordion, index) => {
    const button = accordion.querySelector('.title-container');
    const body = accordion.querySelector('.body');
  
    // Récupère le container de scroll selon la largeur
    const getScrollContainer = () => {
      if (window.innerWidth < 1200) {
        return document.querySelector('.dialog-off-canvas-main-canvas') || window;
      }
      return window;
    };
  
    // Scroll fluide pour container custom
    const smoothScrollTo = (container, targetY, duration = 400) => {
      const start = container.scrollTop;
      const change = targetY - start;
      const startTime = performance.now();
  
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const t = Math.min(elapsed / duration, 1);
        const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  
        container.scrollTop = start + change * ease;
        if (t < 1) requestAnimationFrame(animate);
      };
  
      requestAnimationFrame(animate);
    };
  
    // Scroll vers un accordion donné
    const scrollToAccordion = (accordionEl) => {
      const container = getScrollContainer();
      const offset = window.innerWidth < 576 ? -75 : -140;
  
      if (container === window) {
        const y = accordionEl.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        return;
      }
  
      const containerRect = container.getBoundingClientRect();
      const accordionRect = accordionEl.getBoundingClientRect();
      const y = container.scrollTop + (accordionRect.top - containerRect.top) + offset;
  
      smoothScrollTo(container, y, 300);
    };
  
    // Ouvre le premier accordion par défaut
    if (index === 0) {
      button.setAttribute('aria-expanded', 'true');
      body.style.maxHeight = body.scrollHeight + 'px';
      accordion.classList.add('is-open');
    }
  
    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
  
      // Ferme tous les autres accordions
      document.querySelectorAll('.paragraph--type--accordion').forEach(other => {
        if (other !== accordion) {
          const otherButton = other.querySelector('.title-container');
          const otherBody = other.querySelector('.body');
          otherButton.setAttribute('aria-expanded', 'false');
          otherBody.style.maxHeight = 0;
          other.classList.remove('is-open');
        }
      });
  
      // Toggle actuel
      button.setAttribute('aria-expanded', String(!isExpanded));
  
      if (!isExpanded) {
        body.style.maxHeight = body.scrollHeight + 'px';
        accordion.classList.add('is-open');
  
        const onTransitionEnd = (e) => {
          if (e.propertyName === 'max-height') {
  
            if (window.innerWidth < 576) {
              scrollToAccordion(accordion);
            } else {
              const firstAccordion = document.querySelector('.paragraph--type--accordion');
              scrollToAccordion(firstAccordion);
            }
  
            body.removeEventListener('transitionend', onTransitionEnd);
          }
        };
  
        body.addEventListener('transitionend', onTransitionEnd);
  
      } else {
        body.style.maxHeight = 0;
        accordion.classList.remove('is-open');
      }
    });
  });
}

// ------------------------------
// Mobile Menu
// ------------------------------
function initMobileMenu() {
  const body = document.body;
  const burgerBtn = document.getElementById('btnBurgerJS');
  function toggleMenu() { body.classList.toggle('mobilmenu-open'); }
  //function preventScroll(e) { e.preventDefault(); }

  burgerBtn.onclick = (e) => {
    e.preventDefault();

    const isOpen = body.classList.contains('mobilmenu-open');
    if (!isOpen) {
      toggleMenu();
    } else {
      toggleMenu();
    }
  };
}

// ------------------------------
// Drupal + scripts custom
// ------------------------------
function relaunchScripts() {
  if (window.Drupal && Drupal.attachBehaviors) Drupal.attachBehaviors(document);
  setupHomepageMasonry();
  setupProjetsMasonry();
  if (window.initAccordion) initAccordion();
  if (window.initSliders) initSliders();
  initHeaderAndAccordions();
  initMobileMenu();
  initParallaxTitle();
  
  const path = window.location.pathname.replace(/\/$/, '');
  document.querySelectorAll('header .nav-link').forEach(link => {
    link.classList.remove('is-active');
    const href = link.getAttribute('href').replace(/\/$/, '');
    if (href === path) link.classList.add('is-active');
    const li = link.closest('li');
    if (href === '/projets' && path.startsWith('/projets') && path !== '/projets') {
      if (li) li.classList.add('nav-item-active-trail');
    } else if (li) li.classList.remove('nav-item-active-trail');
  });
  document.querySelectorAll('footer a').forEach(link => {
    link.classList.remove('--actif');
    if (link.getAttribute('href').replace(/\/$/, '') === path) link.classList.add('--actif');
  });
}

// ------------------------------
// Barba.js
// ------------------------------
barba.init({
  //debug: true,
  transitions: [
    {
      name: 'overlay-transition',
      leave({current}) {
        document.body.classList.add('is-page-transition');

        const elements = current.container.querySelectorAll('.in-view'); // Sélectionne tous les éléments avec la classe "in-view
        elements.forEach(el => el.classList.remove('in-view')); // Retire la classe de chacun

        overlay.style.display = 'flex';
        overlay.style.transform = 'translateY(100%)';
        overlay.style.transition = 'transform 0.6s ease';
        logo.style.opacity = 0;
        logo.style.transition = 'none';

        return new Promise(resolve => {
          requestAnimationFrame(() => {
            overlay.style.transform = 'translateY(0)';

            setTimeout(() => {
              if (document.body.classList.contains('mobilmenu-open')) {
                document.body.classList.remove('mobilmenu-open');
              }

              // Masonry + scripts se lancent avant que overlay disparaisse
              setupHomepageMasonry();
              setupProjetsMasonry();
              relaunchScripts();

              resolve();
            }, 600);
          });
        });
      },
      enter({current}) {      
        // 🔹 Relancer scripts + Masonry
        if (header.classList.contains('scrolled')) {
          header.classList.remove('scrolled');
        }
        relaunchScripts();
        updateLogoState();
      
        // Attendre que toutes les images de Masonry soient chargées avant de cacher l'overlay
        const homepage = document.querySelector('.homepage-wrapper .projets-view .flexed');
        const projets = document.querySelector('.projets-wrapper .projets-view .flexed');
      
        const promises = [];
        if (homepage) promises.push(new Promise(r => imagesLoaded(homepage, r)));
        if (projets) promises.push(new Promise(r => imagesLoaded(projets, r)));
      
        Promise.all(promises).then(() => {
          // Tous les items Masonry sont prêts
          // Logo fade-in/fade-out
          logo.style.transition = 'opacity 0.6s ease';
          logo.style.opacity = 1;

          window.scrollTo({ top: 0, behavior: 'auto' });
          scrollContainer.scrollTo({
            top: 0,
            behavior: 'auto'
          });

          setTimeout(() => {
            logo.style.opacity = 0;

            setTimeout(() => {
              overlay.style.transition = 'transform 0.6s ease';
              overlay.style.transform = 'translateY(-100%)';

              setTimeout(() => {
                overlay.style.display = 'none';
                setTimeout(() => {
                  document.body.classList.remove('is-page-transition');
                }, 1);

                setTimeout(() => {
                  initInView();
                }, 500);
              }, 600);
            }, 600);
          }, 600);
        });
      },
    }
  ],
  prevent({ el }) {
    if (!el.href) return false;
    return el.href.includes('/admin') || el.href.includes('/user');
  }
});

// ------------------------------
// Premier chargement / refresh
// ------------------------------
window.addEventListener('load', () => {
  document.body.classList.add('lock-loaded');
  
  playOverlaySequence(true, () => {
    relaunchScripts();
    document.body.classList.remove('is-page-transition');

    setTimeout(() => {
      initInView();
    }, 500);
  });
});
